import { creators } from "../../../mocks/magazine";
import { Link } from "react-router-dom";

export default function MagazineShowcase() {
  const featured = creators.slice(0, 4);

  return (
    <section className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-[#C41E3A] text-xs tracking-[0.3em] uppercase font-semibold mb-4">Fresh Off the Press</p>
            <h2 className="text-4xl md:text-5xl font-serif font-light text-[#2B2B2B] leading-tight">
              Magazines People<br />Actually Love Reading
            </h2>
          </div>
          <Link
            to="/creators"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#C41E3A] hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
          >
            See All Creators
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
        </div>

        {/* Magazine Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {featured.map((creator, index) => (
            <Link
              key={creator.id}
              to="/creators"
              className={`group cursor-pointer ${index === 0 ? "md:row-span-1" : ""}`}
            >
              <div className="relative overflow-hidden rounded-xl mb-4" style={{ aspectRatio: "3/4" }}>
                <img
                  src={creator.cover}
                  alt={creator.magazineTitle}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="text-white text-xs tracking-widest uppercase font-semibold">Meet the Creator</span>
                </div>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-white/90 text-[#2B2B2B] text-xs font-semibold">
                  {creator.frequency}
                </span>
              </div>
              <h3 className="font-serif text-lg text-[#2B2B2B] group-hover:text-[#C41E3A] transition-colors">{creator.magazineTitle}</h3>
              <p className="text-[#8B8B8B] text-sm mt-1">{creator.name} &middot; {creator.niche}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
